<div class="slider-zoom-container" (document:mousemove)="onMouseMove($event)" (document:mouseup)="onMouseUp()">
    <h3 id="zoom" i18n="@@hermes.accessibility.product-images-zoom" class="sr-only"> Zoom </h3>
    <button class="plus" (click)="incrementScale()" id="zoom-in">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43 43" width="43" height="43" focusable="false">
            <g fill="none" fill-rule="evenodd" stroke="#333" stroke-width="2" [attr.transform]="'translate(1 1)'">
                <svg:circle cx="20.5" cy="20.5" r="20.5" fill="transparent" />
                <svg:path stroke-linecap="round" d="M14 20.5h13M20.5 14v13" />
            </g>
        </svg>

        <span i18n="@@hermes.accessibility.product-images-zoom-in" hSrOnlyNoSnippet>
            Zoom in, current {{ currentScale }}%
        </span>
    </button>

    <div #rail class="rail">
        <div
            #thumb
            [attr.role]="'slider'"
            tabindex="0"
            (mousedown)="onMouseDown($event)"
            (keydown)="onKeyDown($event)"
            [ngStyle]="{ 'top.px': positionTop }"
            class="thumb"
            [attr.aria-orientation]="'vertical'"
            [attr.aria-valuemin]="minScale"
            [attr.aria-valuenow]="scale"
            [attr.aria-valuemax]="maxScale"
            [attr.aria-valuetext]="formatValue(scale)"
            [attr.aria-labelledby]="'zoom'">
        </div>
    </div>

    <button id="zoom-out" class="minus" (click)="decrementScale()">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="43" height="43" focusable="false">
            <g fill="none" fill-rule="evenodd" stroke="#333" stroke-width="2">
                <circle cx="20" cy="20" r="19" fill="transparent" />
                <path stroke-linecap="round" d="M14 20.5h13" />
            </g>
        </svg>

        <span i18n="@@hermes.accessibility.product-images-zoom-out" hSrOnlyNoSnippet>
            Zoom out, current {{ currentScale }}%
        </span>
    </button>
</div>
